import { Input, Option, Select, Table, TableColumn, Tooltip } from "element-ui";
import BaseButton from "src/components/UI/BaseButton.vue";
import BaseDropdown from "src/components/UI/BaseDropdown.vue";
import Card from "src/components/UI/Cards/Card.vue";
import BaseCheckbox from "src/components/UI/Inputs/BaseCheckbox.vue";
import BaseInput from "src/components/UI/Inputs/BaseInput.vue";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
    install(Vue) {
        Vue.component(BaseInput.name, BaseInput);
        Vue.component(BaseDropdown.name, BaseDropdown);
        Vue.component(Card.name, Card);
        Vue.component(BaseCheckbox.name, BaseCheckbox);
        Vue.component(BaseButton.name, BaseButton);
        Vue.component(Input.name, Input);
        Vue.component(Table.name, Table);
        Vue.component(TableColumn.name, TableColumn);
        Vue.component(Select.name, Select);
        Vue.component(Option.name, Option);
        Vue.use(Tooltip);
    },
};

export default GlobalComponents;
